import { DoubleDeckerCell } from '@plato/ui-legacy/components/list-views/double-decker-cell';
import { DataText } from '@plato/ui-legacy/components/typography/data-text';
import { DeltaText } from '@plato/ui-legacy/components/typography/delta-text';
import { DeltaTriangle } from '@plato/ui-legacy/components/typography/delta-triangle';
import { NumberOrEmpty } from '@plato/ui-legacy/components/typography/number-or-empty';
import { PercentageOrEmpty } from '@plato/ui-legacy/components/typography/percentage-or-empty';
import React from 'react';
import { CurrencyOrEmpty } from '../../../components/typography/currency-or-empty.tsx';
import { MaskedContent } from '../../customer-mode/components/masked-content.tsx';

export function DeltaDoubleDeckerCell({
    percentage,
    amount,
    masked = false,
    style = 'currency',
}: {
    percentage: number | null;
    amount: number | null;
    style?: 'currency' | 'number';
    masked?: boolean;
}) {
    const up = amount === null || amount === 0 ? null : amount > 0;

    const Masked = masked ? MaskedContent : React.Fragment;
    const DataStyleComponent = style === 'currency' ? CurrencyOrEmpty : NumberOrEmpty;

    return (
        <DoubleDeckerCell
            topLevel={
                <Masked>
                    <DataText>
                        <DeltaText up={up}>
                            <PercentageOrEmpty showEmptyIfZero showPlusSignIfPositive>
                                {percentage}
                            </PercentageOrEmpty>
                            {up !== null && <DeltaTriangle up={up} />}
                        </DeltaText>
                    </DataText>
                </Masked>
            }
            bottomLevel={
                <Masked>
                    <DataText>
                        <DataStyleComponent showEmptyIfZero showPlusSignIfPositive>
                            {amount}
                        </DataStyleComponent>
                    </DataText>
                </Masked>
            }
        />
    );
}
